import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AdminTokenInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('iosc_admin_token');

        let request = req;

        if (token && req.url.indexOf('/api/admin') > -1) {
            request = req.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token
                }
            });
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && req.url.indexOf('/api/admin') > -1) {
                    localStorage.removeItem('iosc_admin_token');
                    localStorage.removeItem('iosc_admin_user');

                    this.router.navigate(['/admin/login']);
                }

                return throwError(error);
            })
        );
    }
}